import React from 'react';
import { Link } from 'react-router-dom';
// import ReactLoading from 'react-loading';
import { connect } from 'react-redux';
// import { this.props.history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as appointmentActions from '../../actions/appointmentActions';
import Pagination from "react-js-pagination";
// import * as SVGICONS from '../../images/img/images';
// import Moment from 'react-moment';
// import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ReactTooltip from 'react-tooltip';
import AppointmentDocs from '../sitemanagement/appointmentDocs';
import AppointmentSym from '../sitemanagement/appointmentSyms';
import * as constant from '../../constants/constant';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import $ from 'jquery';
import * as dashboardActions from "../../actions/dashboardActions";
// import * as constant from '../../constants/constant';

const size = 10;
const styleIcon = {
	paddingRight: 10,
	cursor: 'pointer'
}
class MyAppointmentHistory extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			patientAllHistory: [],
			sortColumnName: '',
			sortOrder: -1,
			activePage: 1,
			count: size,
			totalCount: size,
			symModal: false,
			logoutButton: false
		}
		this.handlePageChange = this.handlePageChange.bind(this);
		this.goToViewConsultation = this.goToViewConsultation.bind(this);
		this.hidedocModal = this.hidedocModal.bind(this);
		this.hidesymModal = this.hidesymModal.bind(this);
		this.sortChanged = this.sortChanged.bind(this);
		this._sortClass = this._sortClass.bind(this);
		this.searchFromDate = this.searchFromDate.bind(this)
		this.searchToDate = this.searchToDate.bind(this)
		this.searchAppointments = this.searchAppointments.bind(this);
		this.appointmentSymptoms = this.appointmentSymptoms.bind(this);
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.toggle = this.toggle.bind(this)
		this._logout = this._logout.bind(this)
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	


	}
	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}

	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	toggle() {
		var windowWidth = $(window).width();
		if (windowWidth < 768) {
			$("body").toggleClass("sidebar-open");
		} else {
			$("body").toggleClass("sidebar-collapse");
		}
	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}
	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		let appDetail = {
			doctorId: localStorage.getItem('userId'),
			patientId: this.props.match.params.patientId,
			count: this.state.count,
			page: pageNumber,
			date1: this.state.searchfromdate,
			date2: this.state.searchtodate
		}
		this.props.actions.getPatientAllHistory(appDetail);
	}

	componentWillMount() {
		let appDetail = {
			doctorId: localStorage.getItem('userId'),
			patientId: this.props.match.params.patientId,
			count: this.state.count,
			page: this.state.activePage
        }
        console.log("appDetail", appDetail)
		this.props.actions.getPatientAllHistory(appDetail);
	}


	componentWillReceiveProps(nextProps) {
        console.log("nextProps", nextProps)
		var state = this.state;
		state.patientAllHistory = (nextProps.patientAllHistory && nextProps.patientAllHistory.appointmentInfo) ? nextProps.patientAllHistory.appointmentInfo : [];
		state.totalCount = nextProps.patientAllHistory && nextProps.patientAllHistory.totalCount ? nextProps.patientAllHistory.totalCount : 0;
		this.setState(state);
	}

	appointmentDocuments(data) {
		// console.log(data, "data");
		this.setState({ docModal: true, appointmentId: data._id, patientId: data.patientId })

	}

	searchFromDate(from) {
		this.setState({ "searchfromdate": from });
	}

	searchToDate(to) {
		this.setState({ "searchtodate": to });
	}


	searchAppointments() {
		let appDetail = {
			doctorId: localStorage.getItem('userId'),
			patientId: this.props.match.params.patientId,
			count: this.state.count,
			page: this.state.activePage,
			date1: this.state.searchfromdate,
			date2: this.state.searchtodate
		}
		this.props.actions.getPatientAllHistory(appDetail);
	}

	appointmentSymptoms(data) {
		this.setState({ symModal: true, appointmentId: data._id, appointmentSymptoms: data.symptoms })

	}

	hidedocModal() {
		this.setState({ docModal: false })
	}

	hidesymModal() {
		this.setState({ symModal: false })
	}

	goToViewConsultation(appointmentId, patientId, item) {
		console.log('item', item)
		debugger // eslint-disable-line
		var consultation = constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.patientId + '/' + item.consultation;
		window.open(
			// 'https://support.wwf.org.uk/earth_hour/index.php?type=individual',
			consultation,
			'_blank' // <- This is what makes it open in a new window.
		  );
		localStorage.setItem('patienthistory', 'true')
		localStorage.setItem('patientId', patientId)
		// this.props.history.push('/specialist/appointment-consultation/' + appointmentId);
	}

	sortChanged(sortColumnName, order, e) {
		e.preventDefault();

		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		let userToken = localStorage.getItem('token');
		let patientId = localStorage.getItem('userId');
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;


		let appDetail = {
			doctorId: localStorage.getItem('userId'),
			patientId: this.props.match.params.patientId,
			sorting: sorting,
			count: this.state.count,
			page: this.state.activePage
		}
		this.props.actions.getPatientAllHistory(appDetail);

	}

	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}
	render() {
		var patientAllHistory = this.state.patientAllHistory;
		// var consultation = item.consultation ? constant.PRODUCTION_IMAGE_URL + 'uploads/' + item.patientId + '/' + item.consultation : '';

		var rows = [];
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var defaultImagePath = user.gender=='Male'? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_m.png': constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_f.png';
		if (user.image == constant.DEFAULT_USER_IMAGE) {
			// var imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
			//image bug fix
			var imagePath = defaultImagePath;
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined )&& user.availabilityCount > 0 )&& user.isVerified == '2');
		var userType = localStorage.getItem('userType');
		return (
			<div>
				<header className="main-header">
				<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button"  onClick={this.toggle}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>

						<div className="col-lg-3 col-md-5">
							{/* <div className="boxMrgB"> */}
							<div className="">
								<div className="input-group date inputBg dateInputfild" style={{ color: '#4d4d4d !important' }}>
									<div className="input-group-addon"><i className="fa ">
										<img src={require('../../images/img/date_input_icon.svg')} /></i></div>
									<DatePicker
										name="fromdate"
										dateFormat="dd-MM-yyyy"
										selected={this.state.searchfromdate}
										onChange={this.searchFromDate}
										placeholderText="From Date"
										maxDate={moment().add(1, 'year')}
										minDate={moment().subtract(1, 'year')}
										showMonthDropdown
										showYearDropdown
										shouldCloseOnSelect={true}
									/>
								</div>
							</div>
						</div>
						<div className="col-lg-3 col-md-5 padding0tab">
							{/* <div className="boxMrgB"> */}
							<div className="">
								<div className="input-group date inputBg dateInputfild" style={{ color: '#4d4d4d !important' }}>
									<div className="input-group-addon"><i className="fa ">
										<img src={require('../../images/img/date_input_icon.svg')} /></i></div>
									<DatePicker
										name="todate"
										dateFormat="dd-MM-yyyy"
										selected={this.state.searchtodate}
										onChange={this.searchToDate}
										placeholderText="To Date"
										maxDate={moment().add(1, 'year')}
										minDate={this.state.searchfromdate ? this.state.searchfromdate : moment().subtract(1, 'year')}
										showMonthDropdown
										showYearDropdown
										shouldCloseOnSelect={true}
									/>

								</div>
							</div>
						</div>
						<div className="col-lg-3 col-md-5 ">
							<button type="button" className="btn btn-warning btn-lg pd-btn btnwidthtab" data-toggle="modal" onClick={this.searchAppointments.bind(this)}>Search</button>
						</div>
						<div className="navbar-custom-menu specialistcustummenutab">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper" >

					{/* this.state.isLoader ? <div className="loaderCenter"> <ReactLoading type={'bars'} color={'blue'} /></div> : */}
					<section className="content container-fluid">
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs">
											<li><Link href="#tab_1" className="active show" data-toggle="tab" > Appointments History</Link></li>
										</ul>
										<div className="tab-content" style={{ "minHeight": 410 }}>
											<div className="tab-pane active" id="tab_1">
												<div id="cbp-vm" className="cbp-vm-switcher cbp-vm-view-grid">
													<div className="cbp-vm-options">

													</div>
													<div className="table-responsive">

														<table className="table table-striped table-bordered table-hover">
															<thead>
																<tr>
																	<th onClick={this.sortChanged.bind(this, 'appointmentDate', this.state.sortOrder)}>
																		Appointment Date
																		<i className={this._sortClass('appointmentdate')}></i>
																	</th>
																	<th onClick={this.sortChanged.bind(this, 'appointmentTime', this.state.sortOrder)}>
																		Appointment Time
																		<i className={this._sortClass('appointmenttime')}></i>
																	</th>
																	<th onClick={this.sortChanged.bind(this, 'appointmentMode', this.state.sortOrder)}>
																		Mode
																		<i className={this._sortClass('appointmentmode')}></i>
																	</th>
																	<th onClick={this.sortChanged.bind(this, 'appointmentStatus', this.state.sortOrder)}>
																		Status
																		<i className={this._sortClass('appointmentstatus')}></i>
																	</th>
																	<th >
																		Health Records
																	</th>
																	{/* <th></th> */}
																</tr>
															</thead>
															<tbody>
																{
																	(patientAllHistory && patientAllHistory.length > 0) ?
																		patientAllHistory.map((item, index) => <tr key={index}>
																			<td>
                                      { item ? moment.parseZone(new Date(item.checkappointmentDate)).format('DD-MM-YYYY'): ''}
																			</td>
																			<td>

                                        {item ? moment.parseZone(new Date(item.checkappointmentDate)).format('h:mm A'): ''}

																			</td>
																			<td>
																				{item.appointmentMode == 1 ? 'F2F' : 'Online'}
																			</td>
																			<td>
																				{item.appointmentStatus == 1 ? 'Not Completed' : ''}
																				{item.appointmentStatus == 2 ? 'Completed' : ''}
																				{item.appointmentStatus == 3 ? 'No show- Specialist' : ''}
																				{item.appointmentStatus == 4 ? 'No show- Patient' : ''}
																				{item.appointmentStatus == 5 ? 'Reserved' : ''}
																			</td>
																			{item.appointmentStatus != 4 && item.appointmentStatus != 3 ? <td>
																				{/* <a data-tip data-for={'global1' + index}> */}
																				<Link onClick={this.goToViewConsultation.bind(this, item._id, item.patientId, item)}>
																					<span className="tooltip-custom fadeEffect tisymtomhover cancelRightTooltip specialist_tooltip" data-title="View Consultation Form">
																						<img src={require('../../images/img/book.png')} style={{ 'cursor': 'pointer' }} />
																					</span>
																				</Link>
																				{/* {consultation ? <span className='tooltip-custom fadeEffect tisymtomhover' data-title="Download Health Record"><a href={consultation} target="_blank"><img src={require('../../images/Download.png')} alt="" className="img-healthrecord" /></a></span> :<span className='tooltip-custom fadeEffect tisymtomhover' data-title="Download Health Record"> <Link><img src={require('../../images/Download.png')} alt="" className="img-healthrecord" /></Link></span>} */}

																				{/* </a> */}
																				{/* <ReactTooltip id={'global1' + index} effect='solid'>
																				<p>View Consultation Form</p>
																			</ReactTooltip> */}

																				{/* <a style={styleIcon} data-tip data-for={'global2' + index}>
																			<img src={require('../../images/img/book.png')} onClick={this.appointmentDocuments.bind(this, item)} style={{ 'cursor': 'pointer' }} />
																			{this.state.docModal ? <AppointmentDocs openModal={this.state.docModal} hideConditionModal={this.hidedocModal} appointmentId={this.state.appointmentId} patientId={this.state.patientId} /> : ''}

																		</a>
																		<ReactTooltip id={'global2' + index} effect='solid'>
																			<p>View Uploaded Symptoms</p>
																		</ReactTooltip> */}

																				{/* <a style={styleIcon} data-tip data-for={'global3' + index}> */}
																				<span className="tooltip-custom fadeEffect tisymtomhover cancelRightTooltip specialist_tooltip" data-title="View Uploaded Documents">
																					<img src={require('../../images/img/book.png')} onClick={this.appointmentDocuments.bind(this, item)} style={{ 'cursor': 'pointer' }} />
																				</span>

																				{this.state.docModal ? <AppointmentDocs openModal={this.state.docModal} hideConditionModal={this.hidedocModal} appointmentId={this.state.appointmentId} patientId={this.state.patientId} /> : ''}
																				{/* </a> */}
																				{/* <ReactTooltip id={'global3' + index} effect='solid'>
																				<p>View Uploaded Documents</p>
																			</ReactTooltip> */}

																				{/* <a style={styleIcon} data-tip data-for={'global4' + index}> */}
																				<span className="tooltip-custom fadeEffect tisymtomhover cancelRightTooltip specialist_tooltip" data-title="View Symptoms">
																					<img src={require('../../images/img/book.png')} onClick={this.appointmentSymptoms.bind(this, item)} style={{ 'cursor': 'pointer' }} /></span>
																				{this.state.symModal ? <AppointmentSym openModal={this.state.symModal} hideConditionModal={this.hidesymModal} appointmentId={this.state.appointmentId} symptoms={this.state.appointmentSymptoms} /> : ''}
																				{/* </a> */}
																				{/* <ReactTooltip id={'global4' + index} effect='solid'>
																				<p>View Symptoms</p>
																			</ReactTooltip> */}


																			</td> : <td>No Health Records</td>}

																		</tr>)
																		: 'There are no records found'
																}
															</tbody>
														</table>
													</div></div>
											</div>
										</div>
									</div>
								</div>
								{(this.state.totalCount && this.state.totalCount > 0) ?
									<div className="row" style={{ 'marginTop': 30 }}>
										<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
										<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
											<Pagination
												prevPageText='Prev'
												nextPageText='Next'
												hideFirstLastPages
												activePage={this.state.activePage}
												itemsCountPerPage={size}
												pageRangeDisplayed={size}
												totalItemsCount={this.state.totalCount}
												onChange={this.handlePageChange.bind(this)}
											/>
										</div>
									</div> : ''}
							</div>
						</div>
					</section>

					<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		patientAllHistory: state.appointment.patientAllHistory,
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(MyAppointmentHistory);
